export const PAR_LEVEL_OUTCOME_LINE =
  'Set par levels on your key products to order the right amount, faster — less over-ordering and fewer stock-outs.'

export const PAR_LEVEL_TOOLTIP_DEFINITION =
  'Par Level = the target stock you want on hand. Shown on the app when ordering so your team knows what to aim for.'

export const DEFAULT_QUANTITY_TOOLTIP_DEFINITION =
  'Default Quantity = the quantity automatically added when ordering.'

export const DEFAULT_QUANTITY_COLUMN_TOOLTIP =
  'Default quantity is what gets added to the basket when staff order this product on the app.'

export const ZONE_COLUMN_TOOLTIP_DEFINITION =
  'Zone = the shopping list group staff see when ordering on the app (e.g. Fridge, Bar). It is not your supplier — it is how you organise your list.'

export const SECONDARY_ZONE_COLUMN_TOOLTIP_DEFINITION =
  'Secondary zone = an optional sub-group shown under the zone (e.g. Top shelf). Leave blank if you do not need it.'

export const ORDERING_DEFAULTS_SECTION_HINT =
  'Default quantity is what gets added to the basket. Par level is your target stock — staff see it on the app when ordering so they can order the right amount, faster.'

export const VENUE_PRODUCTS_BANNER_PAR_LEVEL_BULLET =
  'Set Par Levels so staff see target stock when ordering — order the right amount, faster'
